import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../apiConfig';

const AdminForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setMessage('Please enter your email address.');
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage('Please enter a valid email address.');
      return;
    }
    setLoading(true);
    setMessage('');
    try {
      const res = await fetch(`${API_URL}/admin-forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      setMessage(data.message || 'If the email exists, an OTP has been sent.');
      // Navigate to verification page with email in query
      navigate(`/admin/forgot-password-verify?email=${encodeURIComponent(email)}`);
    } catch (err) {
      console.error(err);
      setMessage('Server error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <header style={styles.topHeader}>
        <img src={require("../assets/logonobg.png")} alt="Logo" style={styles.logo} />
      </header>

      <div style={styles.content}>
        <div style={styles.card}>
          <div style={styles.iconContainer}>
            <div style={styles.iconCircle}>
              <span style={styles.icon}>🔓</span>
            </div>
          </div>
          <h1 style={styles.titleMain}>Admin Forgot Password</h1>
          <p style={styles.subtitle}>Enter your email address and we'll send you a 6-digit code to reset your password.</p>
          
          <form onSubmit={handleSubmit} noValidate>
            <div style={{ textAlign: "left", marginBottom: "8px" }}>
              <label style={styles.label}>Email Address</label>
            </div>
            <input
              type="email"
              placeholder="name@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ ...styles.input, marginBottom: message ? "8px" : "24px" }}
              autoComplete="off"
            />
            {message && (
              <div style={{
                ...(message.includes('sent') ? styles.successText : styles.errorText), 
                textAlign: 'left'
              }}>
                {message}
              </div>
            )}
            <button type="submit" style={styles.button} disabled={loading}>
              {loading ? 'Sending...' : 'Send OTP'}
            </button>
          </form>
          
          <div style={{ marginTop: "24px" }}>
            <button 
              type="button" 
              onClick={() => navigate('/admin-login')}
              style={styles.backButton}
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#f9fafb",
    fontFamily: "'Montserrat', sans-serif",
  },
  topHeader: {
    backgroundColor: '#14291F',
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
  },
  logo: {
    height: '45px',
    objectFit: 'contain'
  },
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "60px 20px",
  },
  card: {
    width: '100%',
    maxWidth: '440px',
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    border: '1px solid #e5e7eb',
    padding: '48px 40px',
    textAlign: 'center',
    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.05), 0 10px 10px -5px rgba(0, 0, 0, 0.02)",
  },
  iconContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "24px",
  },
  iconCircle: {
    width: "80px",
    height: "80px",
    backgroundColor: "#fef3c7",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    fontSize: "36px",
  },
  titleMain: {
    fontFamily: "'Abril Fatface', serif",
    fontSize: '32px',
    color: '#2E4B4C',
    margin: '0 0 12px 0',
    letterSpacing: "0.5px"
  },
  subtitle: {
    fontSize: '14px',
    color: '#6b7280',
    marginBottom: '32px',
    lineHeight: '1.6',
  },
  label: {
    color: "#4b5563",
    fontWeight: "600",
    fontSize: "12px",
    textTransform: "uppercase",
    letterSpacing: "1px",
    marginBottom: "8px",
    display: "inline-block"
  },
  input: {
    width: "100%",
    padding: "16px",
    fontSize: "15px",
    border: "2px solid #e5e7eb",
    borderRadius: "12px",
    boxSizing: "border-box",
    marginBottom: "20px",
    fontWeight: "500",
    color: "#14291F",
    outline: "none",
    transition: "all 0.2s",
    backgroundColor: "#f9fafb"
  },
  button: {
    backgroundColor: "#14291F",
    color: "#fff",
    padding: "16px 30px",
    border: "none",
    borderRadius: "12px",
    cursor: "pointer",
    fontSize: "15px",
    fontWeight: "700",
    width: "100%",
    marginTop: "8px",
    transition: "all 0.2s",
    textTransform: "uppercase",
    letterSpacing: "1px",
    boxShadow: "0 4px 12px rgba(20, 41, 31, 0.15)"
  },
  errorText: {
    color: "#e74c3c",
    fontSize: "12px",
    marginBottom: "16px",
    fontWeight: "500",
    letterSpacing: "0.3px"
  },
  successText: {
    color: "#2E4B4C",
    fontSize: "13px",
    marginBottom: "24px",
    fontWeight: "500",
    padding: "12px",
    backgroundColor: "#f0fdf4",
    borderRadius: "8px",
    border: "1px solid #bbf7d0"
  },
  backButton: {
    background: "none",
    border: "none",
    color: "#6b7280",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    textDecoration: "underline"
  }
};

export default AdminForgotPassword;

